const MAX_CONSULTATION_NUMBER = 1000
export const MAX_NEGATIVATION_NUMBER = 1000

export const REPORT_TYPES = {
  basic: 'Básico',
  intermediate: 'Intermediário',
  advanced: 'Completo'
}

export const FIELDS = [
  {
    icon: 'equifax-file-analysis-2',
    name: 'consultation_quantity',
    label: 'Quantidade de consultas:',
    max: MAX_CONSULTATION_NUMBER
  },
  {
    icon: 'equifax-users-search',
    name: 'consultation_type',
    label: 'Deseja consultar:'
  },
  {
    icon: 'equifax-file',
    name: 'report_type',
    label: 'Relatório escolhido:'
  }
]
